export default "__VITE_ASSET__hgJAXPYE__"